// extracted by mini-css-extract-plugin
export default {"points":"player2Points_points__6BHPh","points__star":"player2Points_points__star__jIg6t"};